@if(formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto">
        <ng-container *ngTemplateOutlet="tplFormContent"/>
        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" [disabled]="!formGroup.valid">Speichern</button>          
        </div>
      </div>
    </dialog>
  </form>
}

<ng-template #tplFormContent>
  <h4 class="text-lg font-bold mb-4">Deadlines bearbeiten</h4>
  <div class="text-muted mb-4">
    Die Deadline für die Erstellung des Arbeitberichtes startet mit dem Einsatzzeitpunkt und nach dem Ablauf erfolgt eine Benachrichtigung.
  </div>
  <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
    <legend  class="bm-fieldset-legend">Deadline 1</legend>

    <label class="bm-fieldset-label">Deadline 1 verwenden</label>
    <label class="bm-label">
      <input type="checkbox" class="bm-checkbox" formControlName="use_deadline"/>
      Deadline 1 verwenden
    </label>
    <label class="bm-fieldset-label">Deadline</label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_days">
      <span class="bm-label w-16">Tage</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_hours">
      <span class="bm-label w-16">h</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_minutes">
      <span class="bm-label w-16">min</span>
    </label>
    <label class="bm-fieldset-label">Per</label>
    <div class="flex flex-col">
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="mail">Mail
      </label>
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="sms">Sms
      </label>
    </div>
  </fieldset>

  <fieldset class="bm-card bm-card-sm bm-fieldset">
    <legend  class="bm-fieldset-legend">Deadline 2</legend>

    <label class="bm-fieldset-label">Deadline 2 verwenden</label>
    <label class="bm-label">
      <input type="checkbox" class="bm-checkbox" formControlName="use_deadline2"/>
      Deadline 2 verwenden
    </label>
    <label class="bm-fieldset-label">Deadline</label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_days2">
      <span class="bm-label w-16">Tage</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_hours2">
      <span class="bm-label w-16">h</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_minutes2">
      <span class="bm-label w-16">min</span>
    </label>
    <label class="bm-fieldset-label">Per</label>
    <div class="flex flex-col">
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="mail2">Mail
      </label>
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="sms2">Sms
      </label>
    </div>
  </fieldset>


  <fieldset class="bm-card bm-card-sm bm-fieldset">
    <legend  class="bm-fieldset-legend">Deadline 3</legend>

    <label class="bm-fieldset-label">Deadline 3 verwenden</label>
    <label class="bm-label">
      <input type="checkbox" class="bm-checkbox" formControlName="use_deadline3"/>
      Deadline 3 verwenden
    </label>
    <label class="bm-fieldset-label">Deadline</label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_days3">
      <span class="bm-label w-16">Tage</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_hours3">
      <span class="bm-label w-16">h</span>
    </label>
    <label class="bm-input">
      <input type="number" min="0" matInput formControlName="deadline_minutes3">
      <span class="bm-label w-16">min</span>
    </label>
    <label class="bm-fieldset-label">Per</label>
    <div class="flex flex-col">
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="mail3">Mail
      </label>
      <label class="bm-label">
        <input type="checkbox" class="bm-checkbox" formControlName="sms3">Sms
      </label>
    </div>
  </fieldset>
</ng-template>